import { debugTracking } from '$lib/debug';
import { shouldTrack } from '$lib/global/tracking/helper';

import omit from 'lodash/omit';

import { integrationsWithIdsInEvents, integrationsWithOutIdsInEvents } from './integrations';
import { getGlobals } from '../globals';

export const trackQuantityEvent = (event: any, properties?: any) => {
    track(event, properties, {
        integrations: integrationsWithOutIdsInEvents,
    });
};

export const trackUniqueEvent = (event: any, properties: any) => {
    track(event, properties, {
        integrations: integrationsWithIdsInEvents,
    });
};

export const track = (event: any, properties: any, override = {}) => {
    debugTracking('-> V4 track request:', !!window.analytics, event, properties, override);

    if (!shouldTrack()) {
        return;
    }

    window.analytics?.track(event, properties, {
        ...override,
        context: generateContext().context,
    });
};

export const page = (pageName: string, properties: any) => {
    debugTracking('-> V4 page request:', !!window.analytics, pageName, properties);

    if (!shouldTrack()) {
        return;
    }

    window.analytics?.page(null, pageName, properties, {
        context: generateContext().context,
        integrations: integrationsWithOutIdsInEvents,
    });
};

export const identify = (traits?: Record<string, unknown>) => {
    debugTracking('-> V4 identify request:', !!window.analytics, traits);

    if (!shouldTrack()) {
        return;
    }

    const globals = getGlobals();

    window.analytics?.identify(globals.anonymousId, traits, generateContext());
};

const generateContext = () => {
    const globals = getGlobals();

    return {
        context: {
            perspective: omit(globals, 'trackingTitles'),
            dictionary: globals.trackingTitles,
            userAgent: window.navigator.userAgent,
            locale: window.navigator.language,
        },
    };
};

export default {
    track,
    page,
    identify,
};
